import React from "react";
import {CheckBoxField, NumberField, SelectField, TextArea, TextField} from "../../../Components/Inputs";
import {GridCell, gridConstants} from "../../../Components/Grid";
import {HtmlDisplay} from "../../../Components/Display/";
import {FORMAT_LIST} from "../../Library/libraryConstants";
import {ORDER_TYPE, PLACE_THE_ORDER_STATUS_LIST} from "../orderConstants";

import type {ListItem} from "../../../Utilities/Types/listUtilities";

interface OrderProcessingFormProps {
    orderProcessingForm: Record<string, any>;
    orderDetails: Record<string, any>;
    vendors: ListItem[] | null;
    formVisibility: Record<string, any>;
}

export const OrderProcessingForm = ({
                                        orderProcessingForm,
                                        orderDetails,
                                        vendors,
                                        formVisibility

                                    }: OrderProcessingFormProps) => {

    return <>
        {
            formVisibility.canPlaceAnOrder &&
            <>
                <GridCell>
                    <HtmlDisplay html={`<div><h3>Step 1: Place an Order </h3></div>`}/>
                </GridCell>

                <SelectField
                    {...orderProcessingForm.formatOrdered}
                    medium_columns={gridConstants.column.SIX}
                    label={`Medium Requested`}
                    options={FORMAT_LIST}/>

                <SelectField
                    {...orderProcessingForm.orderStatus}
                    medium_columns={gridConstants.column.SIX}
                    options={PLACE_THE_ORDER_STATUS_LIST}/>

                <SelectField
                    {...orderProcessingForm.vendorId}
                    medium_columns={gridConstants.column.SIX}
                    label={`Vendor`}
                    options={vendors}
                />
            </>
        }

        {
            formVisibility.canReceiveOrder &&
            <>
                <GridCell>
                    <HtmlDisplay html={`<div><h3>Step 2: Order Fulfillment </h3></div>`}/>
                </GridCell>

                <TextField
                    {...orderProcessingForm.volumesReceived}
                    helpText={"Enter volumes, separated by commas"}
                    medium_columns={gridConstants.column.SIX}/>

                <NumberField
                    {...orderProcessingForm.numberOfVolumesReceived}
                    isWholeNumberOnly
                    isPositiveNumberOnly
                    medium_columns={gridConstants.column.SIX}/>

                {
                    orderDetails.orderType === ORDER_TYPE.SpecialOrderRequest &&
                    <TextArea
                        {...orderProcessingForm.description}
                        medium_columns={gridConstants.column.SIX}/>
                }

                <CheckBoxField
                    {...orderProcessingForm.isOrderComplete}
                    checked={!!orderProcessingForm.isOrderComplete.value}
                    label={"Order Is Complete"}
                    value={orderProcessingForm.isOrderComplete.value ? "" : "true"}
                />
            </>
        }

    </>;
};

